/**
 * Generated file, do not edit directly!
 */

/** @public */
const customPropertiesUnified = {
  /** Use as the default border style. */
  '--dt-borders-style-default': 'solid',
  /** Use to indicate interactive text. */
  '--dt-borders-style-dashed': 'dashed',
  /** Use as the default border width. */
  '--dt-borders-width-default': '1px',
  /** Use to emphasize borders. This can be useful to clearly separate content. */
  '--dt-borders-width-emphasized': '2px',
  /** Use as the subdued border radius for surfaces. */
  '--dt-borders-radius-surface-subdued': '9px',
  /** Use as the default border radius for surfaces. */
  '--dt-borders-radius-surface-default': '12px',
  /** Use as the subdued border radius for containers. */
  '--dt-borders-radius-container-subdued': '6px',
  /** Use as the default border radius for containers. */
  '--dt-borders-radius-container-default': '9px',
  /** Use as the subdued border radius for fields. */
  '--dt-borders-radius-field-subdued': '3px',
  /** Use as the default border radius for fields. */
  '--dt-borders-radius-field-default': '6px',
  /** Use for rounded or pill-like shapes. */
  '--dt-borders-radius-field-emphasized': '9999px',
  /** Use as the default level of elevation. */
  '--dt-box-shadows-surface-flat-rest': '0px 0px 0px 1px #f0f0f514',
  /** Use as the default level of elevation when a user's pointer is over an interactive surface. */
  '--dt-box-shadows-surface-flat-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 4px 8px #112c',
  /** Use as the default level of elevation when the user is pressing an interactive surface. */
  '--dt-box-shadows-surface-flat-active': '0px 0px 0px 1px #f0f0f514',
  /** Use as the default level of elevation when moving a surface, on drag-and-drop interaction. */
  '--dt-box-shadows-surface-flat-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 13px 8px #112c',
  /** Use for raised surfaces. */
  '--dt-box-shadows-surface-raised-rest':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 4px 8px #112c',
  /** Use when a user's pointer is over an interactive raised surface. */
  '--dt-box-shadows-surface-raised-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 7px 8px #112c',
  /** Use when the user is pressing an interactive raised surface. */
  '--dt-box-shadows-surface-raised-active':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 4px 8px #112c',
  /** Use when moving a raised surface, on drag-and-drop interaction. */
  '--dt-box-shadows-surface-raised-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 13px 8px #112c',
  /** Use for floating surfaces. */
  '--dt-box-shadows-surface-floating-rest':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 7px 8px #112c',
  /** Use when a user's pointer is over an interactive floating surface. */
  '--dt-box-shadows-surface-floating-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 10px 8px #112c',
  /** Use when the user is pressing an interactive floating surface. */
  '--dt-box-shadows-surface-floating-active':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 7px 8px #112c',
  /** Use when moving a floating surface, on drag-and-drop interaction. */
  '--dt-box-shadows-surface-floating-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 13px 8px #112c',
  /** Use for emphasized neutral button and input in rest state. */
  '--dt-box-shadows-field-neutral-emphasized-rest':
    'inset 0px 0px 0px 1px #ebecff1f, inset 0px 1px 0px #ebecff14, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #112',
  /** Use for emphasized neutral button and input in hover state. */
  '--dt-box-shadows-field-neutral-emphasized-hover':
    'inset 0px 0px 0px 1px #ebecff1f, inset 0px 1px 0px #ebecff14, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #3b3b52',
  /** Use for emphasized neutral button and input in active state. */
  '--dt-box-shadows-field-neutral-emphasized-active':
    'inset 0px 0px 0px 1px #ebecff1f, inset 0px 1px 0px #ebecff14, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #44445c',
  /** Use for accentuated neutral button. */
  '--dt-box-shadows-field-neutral-accent':
    'inset 0px 0px 0px 1px #ffffff4d, inset 0px 1px 0px #ffffff8c, 0px 1px 1px -1px #f0f0f51f',
  /** Use for disabled neutral button and input. */
  '--dt-box-shadows-field-neutral-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  /** Use for emphasized primary button in rest state. */
  '--dt-box-shadows-field-primary-emphasized-rest':
    'inset 0px 0px 0px 1px #eef1ff0f, inset 0px 1px 0px #eef1ff1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #313150',
  /** Use for emphasized primary button in hover state. */
  '--dt-box-shadows-field-primary-emphasized-hover':
    'inset 0px 0px 0px 1px #eef1ff0f, inset 0px 1px 0px #eef1ff1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #39395d',
  /** Use for emphasized primary button in active state. */
  '--dt-box-shadows-field-primary-emphasized-active':
    'inset 0px 0px 0px 1px #eef1ff0f, inset 0px 1px 0px #eef1ff1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #42426a',
  /** Use for accentuated primary button. */
  '--dt-box-shadows-field-primary-accent':
    'inset 0px 0px 0px 1px #eef1ff26, inset 0px 1px 0px #eef1ff40, 0px 1px 1px -1px #f0f0f51f',
  /** Use for disabled primary button. */
  '--dt-box-shadows-field-primary-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  /** Use for emphasized success button in rest state. */
  '--dt-box-shadows-field-success-emphasized-rest':
    'inset 0px 0px 0px 1px #aafef50f, inset 0px 1px 0px #aafef51a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #273644',
  /** Use for emphasized success button in hover state. */
  '--dt-box-shadows-field-success-emphasized-hover':
    'inset 0px 0px 0px 1px #aafef50f, inset 0px 1px 0px #aafef51a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #2b404c',
  /** Use for emphasized success button in active state. */
  '--dt-box-shadows-field-success-emphasized-active':
    'inset 0px 0px 0px 1px #aafef50f, inset 0px 1px 0px #aafef51a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #304a54',
  /** Use for accentuated success button. */
  '--dt-box-shadows-field-success-accent':
    'inset 0px 0px 0px 1px #aafef533, inset 0px 1px 0px #aafef540, 0px 1px 1px -1px #f0f0f51f',
  /** Use for disabled success button. */
  '--dt-box-shadows-field-success-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  /** Use for emphasized warning button in rest state. */
  '--dt-box-shadows-field-warning-emphasized-rest':
    'inset 0px 0px 0px 1px #ffecc30f, inset 0px 1px 0px #ffecc31a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #403537',
  /** Use for emphasized warning button in hover state. */
  '--dt-box-shadows-field-warning-emphasized-hover':
    'inset 0px 0px 0px 1px #ffecc30f, inset 0px 1px 0px #ffecc31a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #4e3e39',
  /** Use for emphasized warning button in active state. */
  '--dt-box-shadows-field-warning-emphasized-active':
    'inset 0px 0px 0px 1px #ffecc30f, inset 0px 1px 0px #ffecc31a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #5d483c',
  /** Use for accentuated warning button. */
  '--dt-box-shadows-field-warning-accent':
    'inset 0px 0px 0px 1px #ffecc340, inset 0px 1px 0px #ffecc373, 0px 1px 1px -1px #f0f0f51f',
  /** Use for disabled warning button. */
  '--dt-box-shadows-field-warning-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  /** Use for emphasized critical button and input in rest state. */
  '--dt-box-shadows-field-critical-emphasized-rest':
    'inset 0px 0px 0px 1px #ffeceb0f, inset 0px 1px 0px #ffeceb1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #3c2131',
  /** Use for emphasized critical button and input in hover state. */
  '--dt-box-shadows-field-critical-emphasized-hover':
    'inset 0px 0px 0px 1px #ffeceb0f, inset 0px 1px 0px #ffeceb1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #482332',
  /** Use for emphasized critical button and input in active state. */
  '--dt-box-shadows-field-critical-emphasized-active':
    'inset 0px 0px 0px 1px #ffeceb0f, inset 0px 1px 0px #ffeceb1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #542433',
  /** Use for accentuated critical button. */
  '--dt-box-shadows-field-critical-accent':
    'inset 0px 0px 0px 1px #ffeceb33, inset 0px 1px 0px #ffeceb40, 0px 1px 1px -1px #f0f0f51f',
  /** Use for disabled critical button and input. */
  '--dt-box-shadows-field-critical-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  /** Use with `@media` `max-width` to apply styles to mobile-sized screens. */
  '--dt-breakpoints-max-mobile': '640px',
  /** Use with `@media` `max-width` to apply styles to tablets and smaller screens. */
  '--dt-breakpoints-max-tablet': '960px',
  /** Use with `@media` `max-width` to apply styles to desktops and smaller screens. */
  '--dt-breakpoints-max-desktop': '1920px',
  /** Use this with `@media` `min-width`, to apply styles to tablet and wider screen sizes. */
  '--dt-breakpoints-min-tablet': '641px',
  /** Use this with `@media` `min-width`, to apply styles to desktop and wider screen sizes. */
  '--dt-breakpoints-min-desktop': '961px',
  /** Use this with `@media` `min-width`, to apply styles to widescreen desktop and wider screen sizes. */
  '--dt-breakpoints-min-widescreen': '1921px',
  '--dt-colors-theme-foreground-10': '#f0f0f5',
  '--dt-colors-theme-foreground-20': '#112',
  '--dt-colors-theme-background-10': '#19192c',
  '--dt-colors-theme-background-20': '#112',
  '--dt-colors-theme-background-shell-default': '#141419',
  '--dt-colors-theme-background-surface-backdrop-embedded': '#112c',
  '--dt-colors-theme-neutral-10': '#212135',
  '--dt-colors-theme-neutral-20': '#292a3e',
  '--dt-colors-theme-neutral-30': '#323248',
  '--dt-colors-theme-neutral-40': '#3b3b52',
  '--dt-colors-theme-neutral-50': '#44445c',
  '--dt-colors-theme-neutral-60': '#4d4e66',
  '--dt-colors-theme-neutral-70': '#a0a1c0',
  '--dt-colors-theme-neutral-80': '#b0b1d0',
  '--dt-colors-theme-neutral-90': '#bfc0e1',
  '--dt-colors-theme-primary-10': '#212138',
  '--dt-colors-theme-primary-20': '#292944',
  '--dt-colors-theme-primary-30': '#313150',
  '--dt-colors-theme-primary-40': '#39395d',
  '--dt-colors-theme-primary-50': '#42426a',
  '--dt-colors-theme-primary-60': '#4a4b78',
  '--dt-colors-theme-primary-70': '#999bed',
  '--dt-colors-theme-primary-80': '#a8abfe',
  '--dt-colors-theme-primary-90': '#b8bbff',
  '--dt-colors-theme-success-10': '#1e2234',
  '--dt-colors-theme-success-20': '#222c3c',
  '--dt-colors-theme-success-30': '#273644',
  '--dt-colors-theme-success-40': '#2b404c',
  '--dt-colors-theme-success-50': '#304a54',
  '--dt-colors-theme-success-60': '#34545d',
  '--dt-colors-theme-success-70': '#5eb1a9',
  '--dt-colors-theme-success-80': '#6ec1b9',
  '--dt-colors-theme-success-90': '#7ed1c9',
  '--dt-colors-theme-warning-10': '#252230',
  '--dt-colors-theme-warning-20': '#332c34',
  '--dt-colors-theme-warning-30': '#403537',
  '--dt-colors-theme-warning-40': '#4e3e39',
  '--dt-colors-theme-warning-50': '#5d483c',
  '--dt-colors-theme-warning-60': '#6c523e',
  '--dt-colors-theme-warning-70': '#eea746',
  '--dt-colors-theme-warning-80': '#ffb758',
  '--dt-colors-theme-warning-90': '#ffc974',
  '--dt-colors-theme-critical-10': '#251c2e',
  '--dt-colors-theme-critical-20': '#301f2f',
  '--dt-colors-theme-critical-30': '#3c2131',
  '--dt-colors-theme-critical-40': '#482332',
  '--dt-colors-theme-critical-50': '#542433',
  '--dt-colors-theme-critical-60': '#602634',
  '--dt-colors-theme-critical-70': '#c82d40',
  '--dt-colors-theme-critical-80': '#b61532',
  '--dt-colors-theme-critical-90': '#a50024',
  /** Use for the background of your app. */
  '--dt-colors-background-base-default': '#19192c',
  /** Use as the backdrop for surfaces to reduce the visual noise of background elements. */
  '--dt-colors-background-surface-backdrop': '#19192ccc',
  /** Use as the backdrop for embedded overlays to reduce the visual noise of background elements. */
  '--dt-colors-background-surface-backdrop-embedded': '#112c',
  /** Use for default surface background. */
  '--dt-colors-background-surface-default': '#112',
  /** Use for subtle containers. */
  '--dt-colors-background-container-neutral-subdued': '#19192c',
  /** Use for default containers. */
  '--dt-colors-background-container-neutral-default': '#212135',
  /** Use for emphasized neutral containers that draw attention. */
  '--dt-colors-background-container-neutral-emphasized': '#292a3e',
  /** Use for accentuated neutral containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-neutral-accent': '#a0a1c0',
  /** Use for default primary color containers. */
  '--dt-colors-background-container-primary-default': '#212138',
  /** Use for emphasized primary color containers that draw attention. */
  '--dt-colors-background-container-primary-emphasized': '#292944',
  /** Use for accentuated primary color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-primary-accent': '#999bed',
  /** Use for default success color containers. */
  '--dt-colors-background-container-success-default': '#1e2234',
  /** Use for emphasized success color containers that draw attention. */
  '--dt-colors-background-container-success-emphasized': '#222c3c',
  /** Use for accentuated success color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-success-accent': '#5eb1a9',
  /** Use for default warning color containers. */
  '--dt-colors-background-container-warning-default': '#252230',
  /** Use for emphasized warning color containers that draw attention. */
  '--dt-colors-background-container-warning-emphasized': '#332c34',
  /** Use for accentuated warning color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-warning-accent': '#eea746',
  /** Use for default critical color containers. */
  '--dt-colors-background-container-critical-default': '#251c2e',
  /** Use for emphasized critical color containers that draw attention. */
  '--dt-colors-background-container-critical-emphasized': '#301f2f',
  /** Use for accentuated critical color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-critical-accent': '#c82d40',
  /** Use for disabled neutral fields. */
  '--dt-colors-background-field-neutral-disabled': '#32324880',
  /** Use for default neutral fields. */
  '--dt-colors-background-field-neutral-default': '#32324800',
  /** Use for hover interaction on default neutral fields. */
  '--dt-colors-background-field-neutral-default-hover': '#3b3b52',
  /** Use for click interaction on default neutral fields. */
  '--dt-colors-background-field-neutral-default-active': '#44445c',
  /** Use for emphasized neutral fields. */
  '--dt-colors-background-field-neutral-emphasized': '#323248',
  /** Use for hover interaction on emphasized neutral fields. */
  '--dt-colors-background-field-neutral-emphasized-hover': '#3b3b52',
  /** Use for click interaction on emphasized neutral fields. */
  '--dt-colors-background-field-neutral-emphasized-active': '#44445c',
  /** Use for accentuated neutral fields. Use sparingly. */
  '--dt-colors-background-field-neutral-accent': '#a0a1c0',
  /** Use for hover interaction on accentuated neutral fields. */
  '--dt-colors-background-field-neutral-accent-hover': '#b0b1d0',
  /** Use for click interaction on accentuated neutral fields. */
  '--dt-colors-background-field-neutral-accent-active': '#bfc0e1',
  /** Use for disabled primary fields. */
  '--dt-colors-background-field-primary-disabled': '#32324880',
  /** Use for default primary fields. */
  '--dt-colors-background-field-primary-default': '#31315000',
  /** Use for hover interaction on default primary fields. */
  '--dt-colors-background-field-primary-default-hover': '#39395d',
  /** Use for click interaction on default primary fields. */
  '--dt-colors-background-field-primary-default-active': '#42426a',
  /** Use for emphasized primary fields. */
  '--dt-colors-background-field-primary-emphasized': '#313150',
  /** Use for hover interaction on emphasized primary fields. */
  '--dt-colors-background-field-primary-emphasized-hover': '#39395d',
  /** Use for click interaction on emphasized primary fields. */
  '--dt-colors-background-field-primary-emphasized-active': '#42426a',
  /** Use for accentuated primary fields. Use sparingly. */
  '--dt-colors-background-field-primary-accent': '#999bed',
  /** Use for hover interaction on accentuated primary fields. */
  '--dt-colors-background-field-primary-accent-hover': '#a8abfe',
  /** Use for click interaction on accentuated primary fields. */
  '--dt-colors-background-field-primary-accent-active': '#b8bbff',
  /** Use for disabled success fields. */
  '--dt-colors-background-field-success-disabled': '#32324880',
  /** Use for default success fields. */
  '--dt-colors-background-field-success-default': '#27364400',
  /** Use for hover interaction on default success fields. */
  '--dt-colors-background-field-success-default-hover': '#2b404c',
  /** Use for click interaction on default success fields. */
  '--dt-colors-background-field-success-default-active': '#304a54',
  /** Use for emphasized success fields. */
  '--dt-colors-background-field-success-emphasized': '#273644',
  /** Use for hover interaction on emphasized success fields. */
  '--dt-colors-background-field-success-emphasized-hover': '#2b404c',
  /** Use for click interaction on emphasized success fields. */
  '--dt-colors-background-field-success-emphasized-active': '#304a54',
  /** Use for accentuated success fields. Use sparingly. */
  '--dt-colors-background-field-success-accent': '#5eb1a9',
  /** Use for hover interaction on accentuated success fields. */
  '--dt-colors-background-field-success-accent-hover': '#6ec1b9',
  /** Use for click interaction on accentuated success fields. */
  '--dt-colors-background-field-success-accent-active': '#7ed1c9',
  /** Use for disabled warning fields. */
  '--dt-colors-background-field-warning-disabled': '#32324880',
  /** Use for default warning fields. */
  '--dt-colors-background-field-warning-default': '#40353700',
  /** Use for hover interaction on default warning fields. */
  '--dt-colors-background-field-warning-default-hover': '#4e3e39',
  /** Use for click interaction on default warning fields. */
  '--dt-colors-background-field-warning-default-active': '#5d483c',
  /** Use for emphasized warning fields. */
  '--dt-colors-background-field-warning-emphasized': '#403537',
  /** Use for hover interaction on emphasized warning fields. */
  '--dt-colors-background-field-warning-emphasized-hover': '#4e3e39',
  /** Use for click interaction on emphasized warning fields. */
  '--dt-colors-background-field-warning-emphasized-active': '#5d483c',
  /** Use for accentuated warning fields. Use sparingly. */
  '--dt-colors-background-field-warning-accent': '#eea746',
  /** Use for hover interaction on accentuated warning fields. */
  '--dt-colors-background-field-warning-accent-hover': '#ffb758',
  /** Use for click interaction on accentuated warning fields. */
  '--dt-colors-background-field-warning-accent-active': '#ffc974',
  /** Use for disabled critical fields. */
  '--dt-colors-background-field-critical-disabled': '#32324880',
  /** Use for default critical fields. */
  '--dt-colors-background-field-critical-default': '#3c213100',
  /** Use for hover interaction on default critical fields. */
  '--dt-colors-background-field-critical-default-hover': '#482332',
  /** Use for click interaction on default critical fields. */
  '--dt-colors-background-field-critical-default-active': '#542433',
  /** Use for emphasized critical fields. */
  '--dt-colors-background-field-critical-emphasized': '#3c2131',
  /** Use for hover interaction on emphasized critical fields. */
  '--dt-colors-background-field-critical-emphasized-hover': '#482332',
  /** Use for click interaction on emphasized critical fields. */
  '--dt-colors-background-field-critical-emphasized-active': '#542433',
  /** Use for accentuated critical fields. Use sparingly. */
  '--dt-colors-background-field-critical-accent': '#c82d40',
  /** Use for hover interaction on accentuated critical fields. */
  '--dt-colors-background-field-critical-accent-hover': '#b61532',
  /** Use for click interaction on accentuated critical fields. */
  '--dt-colors-background-field-critical-accent-active': '#a50024',
  /** Use for the shell background. */
  '--dt-colors-background-shell-default': '#141419',
  /** Use as the color for drop-shadows. */
  '--dt-colors-box-shadow-default': '#112',
  /** Use as the default border color in a disabled state. */
  '--dt-colors-border-neutral-disabled': '#3b3b5280',
  /** Use as the default border color. */
  '--dt-colors-border-neutral-default': '#3b3b52',
  /** Use as default border color on hover interaction. */
  '--dt-colors-border-neutral-default-hover': '#44445c',
  /** Use as default border color on click interaction. */
  '--dt-colors-border-neutral-default-active': '#4d4e66',
  /** Use as the border color of accentuated elements. */
  '--dt-colors-border-neutral-accent': '#b1b2d2',
  /** Use as border color of accentuated elements on hover interaction. */
  '--dt-colors-border-neutral-accent-hover': '#cecff0',
  /** Use as border color of accentuated elements on click interaction. */
  '--dt-colors-border-neutral-accent-active': '#ebecff',
  /** Use as border color for disabled elements in accentuated context. */
  '--dt-colors-border-neutral-on-accent-disabled': '#1f203333',
  /** Use as border color for elements in accentuated context. */
  '--dt-colors-border-neutral-on-accent-default': '#1f2033',
  /** Use as border color for elements in accentuated context on hover interaction. */
  '--dt-colors-border-neutral-on-accent-default-hover': '#1f2033cc',
  /** Use as border color for elements in accentuated context on click interaction. */
  '--dt-colors-border-neutral-on-accent-default-active': '#1f203399',
  /** Use as border color of subtle elements. */
  '--dt-colors-border-neutral-subdued': '#323248',
  /** Use as border color of subtle elements on hover interaction. */
  '--dt-colors-border-neutral-subdued-hover': '#44445c',
  /** Use for click interactions on subtle elements. */
  '--dt-colors-border-neutral-subdued-active': '#4d4e66',
  /** Use as border primary color in a disabled state. */
  '--dt-colors-border-primary-disabled': '#3b3b5280',
  /** Use as the default primary border color. */
  '--dt-colors-border-primary-default': '#39395d',
  /** Use as default border primary color on hover interaction. */
  '--dt-colors-border-primary-default-hover': '#42426a',
  /** Use as default border primary color on click interaction. */
  '--dt-colors-border-primary-default-active': '#4a4b78',
  /** Use as the border color of primary accentuated elements. */
  '--dt-colors-border-primary-accent': '#adb0ff',
  /** Use as border color of primary accentuated elements on hover interaction. */
  '--dt-colors-border-primary-accent-hover': '#ccd0ff',
  /** Use as border color of primary accentuated elements on click interaction. */
  '--dt-colors-border-primary-accent-active': '#eef1ff',
  /** Use as border color for disabled elements in primary accentuated context. */
  '--dt-colors-border-primary-on-accent-disabled': '#1f203733',
  /** Use as border color for elements in primary accentuated context. */
  '--dt-colors-border-primary-on-accent-default': '#1f2037',
  /** Use as border color for elements in primary accentuated context on hover interaction. */
  '--dt-colors-border-primary-on-accent-default-hover': '#1f2037cc',
  /** Use as border color for elements in primary accentuated context on click interaction. */
  '--dt-colors-border-primary-on-accent-default-active': '#1f203799',
  /** Use as border success color in a disabled state. */
  '--dt-colors-border-success-disabled': '#3b3b5280',
  /** Use as the default success border color. */
  '--dt-colors-border-success-default': '#2b404c',
  /** Use as default border success color on hover interaction. */
  '--dt-colors-border-success-default-hover': '#304a54',
  /** Use as default border success color on click interaction. */
  '--dt-colors-border-success-default-active': '#34545d',
  /** Use as the border color of success accentuated elements. */
  '--dt-colors-border-success-accent': '#6fc3ba',
  /** Use as border color of success accentuated elements on hover interaction. */
  '--dt-colors-border-success-accent-hover': '#8ce0d7',
  /** Use as border color of success accentuated elements on click interaction. */
  '--dt-colors-border-success-accent-active': '#aafef5',
  /** Use as border color for disabled elements in success accentuated context. */
  '--dt-colors-border-success-on-accent-disabled': '#1a233233',
  /** Use as border color for elements in success accentuated context. */
  '--dt-colors-border-success-on-accent-default': '#1a2332',
  /** Use as border color for elements in success accentuated context on hover interaction. */
  '--dt-colors-border-success-on-accent-default-hover': '#1a2332cc',
  /** Use as border color for elements in success accentuated context on click interaction. */
  '--dt-colors-border-success-on-accent-default-active': '#1a233299',
  /** Use as border warning color in a disabled state. */
  '--dt-colors-border-warning-disabled': '#3b3b5280',
  /** Use as the default warning border color. */
  '--dt-colors-border-warning-default': '#4e3e39',
  /** Use as default border warning color on hover interaction. */
  '--dt-colors-border-warning-default-hover': '#5d483c',
  /** Use as default border warning color on click interaction. */
  '--dt-colors-border-warning-default-active': '#6c523e',
  /** Use as the border color of warning accentuated elements. */
  '--dt-colors-border-warning-accent': '#eea83f',
  /** Use as border color of warning accentuated elements on hover interaction. */
  '--dt-colors-border-warning-accent-hover': '#ffc563',
  /** Use as border color of warning accentuated elements on click interaction. */
  '--dt-colors-border-warning-accent-active': '#ffecc3',
  /** Use as border color for disabled elements in warning accentuated context. */
  '--dt-colors-border-warning-on-accent-disabled': '#27212633',
  /** Use as border color for elements in warning accentuated context. */
  '--dt-colors-border-warning-on-accent-default': '#272126',
  /** Use as border color for elements in warning accentuated context on hover interaction. */
  '--dt-colors-border-warning-on-accent-default-hover': '#272126cc',
  /** Use as border color for elements in warning accentuated context on click interaction. */
  '--dt-colors-border-warning-on-accent-default-active': '#27212699',
  /** Use as border critical color in a disabled state. */
  '--dt-colors-border-critical-disabled': '#3b3b5280',
  /** Use as the default critical border color. */
  '--dt-colors-border-critical-default': '#482332',
  /** Use as default border critical color on hover interaction. */
  '--dt-colors-border-critical-default-hover': '#542433',
  /** Use as default border critical color on click interaction. */
  '--dt-colors-border-critical-default-active': '#602634',
  /** Use as the border color of critical accentuated elements. */
  '--dt-colors-border-critical-accent': '#ff999c',
  /** Use as border color of critical accentuated elements on hover interaction. */
  '--dt-colors-border-critical-accent-hover': '#ffc1c1',
  /** Use as border color of critical accentuated elements on click interaction. */
  '--dt-colors-border-critical-accent-active': '#ffeceb',
  /** Use as border color for disabled elements in critical accentuated context. */
  '--dt-colors-border-critical-on-accent-disabled': '#f9f1f333',
  /** Use as border color for elements in critical accentuated context. */
  '--dt-colors-border-critical-on-accent-default': '#f9f1f3',
  /** Use as border color for elements in critical accentuated context on hover interaction. */
  '--dt-colors-border-critical-on-accent-default-hover': '#f9f1f3cc',
  /** Use as border color for elements in critical accentuated context on click interaction. */
  '--dt-colors-border-critical-on-accent-default-active': '#f9f1f399',
  /** Use for text color on disabled state. */
  '--dt-colors-text-neutral-disabled': '#b1b2d280',
  /** Use for subtle, understated text color. */
  '--dt-colors-text-neutral-subdued': '#b1b2d2',
  /** Use for subtle, understated text color on hover interaction. */
  '--dt-colors-text-neutral-subdued-hover': '#cecff0',
  /** Use for subtle, understated text color on click interaction. */
  '--dt-colors-text-neutral-subdued-active': '#ebecff',
  /** Use as the default text color. */
  '--dt-colors-text-neutral-default': '#ebecff',
  /** Use as the default text color on hover interaction. */
  '--dt-colors-text-neutral-default-hover': '#cecff0',
  /** Use as the default text color on click interaction. */
  '--dt-colors-text-neutral-default-active': '#b1b2d2',
  /** Use as text color for disabled elements in accentuated context. */
  '--dt-colors-text-neutral-on-accent-disabled': '#1f203380',
  /** Use as text color for elements in accentuated context. */
  '--dt-colors-text-neutral-on-accent-default': '#1f2033',
  /** Use as text color for elements in accentuated context on hover interaction. */
  '--dt-colors-text-neutral-on-accent-default-hover': '#1f2033cc',
  /** Use as text color for elements in accentuated context on click interaction. */
  '--dt-colors-text-neutral-on-accent-default-active': '#1f203399',
  /** Use for primary text color on disabled state. */
  '--dt-colors-text-primary-disabled': '#b1b2d280',
  /** Use as the default primary text color. */
  '--dt-colors-text-primary-default': '#adb0ff',
  /** Use as the default primary text color on hover interaction. */
  '--dt-colors-text-primary-default-hover': '#ccd0ff',
  /** Use as the default primary text color on click interaction. */
  '--dt-colors-text-primary-default-active': '#eef1ff',
  /** Use as text color for disabled elements in primary accentuated context. */
  '--dt-colors-text-primary-on-accent-disabled': '#1f203780',
  /** Use as text color for elements in primary accentuated context. */
  '--dt-colors-text-primary-on-accent-default': '#1f2037',
  /** Use as text color for elements in primary accentuated context on hover interaction. */
  '--dt-colors-text-primary-on-accent-default-hover': '#1f2037cc',
  /** Use as text color for elements in primary accentuated context on click interaction. */
  '--dt-colors-text-primary-on-accent-default-active': '#1f203799',
  /** Use for success text color on disabled state. */
  '--dt-colors-text-success-disabled': '#b1b2d280',
  /** Use as the default success text color. */
  '--dt-colors-text-success-default': '#6fc3ba',
  /** Use as the default success text color on hover interaction. */
  '--dt-colors-text-success-default-hover': '#8ce0d7',
  /** Use as the default success text color on click interaction. */
  '--dt-colors-text-success-default-active': '#aafef5',
  /** Use as text color for disabled elements in success accentuated context. */
  '--dt-colors-text-success-on-accent-disabled': '#1a233280',
  /** Use as text color for elements in success accentuated context. */
  '--dt-colors-text-success-on-accent-default': '#1a2332',
  /** Use as text color for elements in success accentuated context on hover interaction. */
  '--dt-colors-text-success-on-accent-default-hover': '#1a2332cc',
  /** Use as text color for elements in success accentuated context on click interaction. */
  '--dt-colors-text-success-on-accent-default-active': '#1a233299',
  /** Use for warning text color on disabled state. */
  '--dt-colors-text-warning-disabled': '#b1b2d280',
  /** Use as the default warning text color. */
  '--dt-colors-text-warning-default': '#eea83f',
  /** Use as the default warning text color on hover interaction. */
  '--dt-colors-text-warning-default-hover': '#ffc563',
  /** Use as the default warning text color on click interaction. */
  '--dt-colors-text-warning-default-active': '#ffecc3',
  /** Use as text color for disabled elements in warning accentuated context. */
  '--dt-colors-text-warning-on-accent-disabled': '#27212680',
  /** Use as text color for elements in warning accentuated context. */
  '--dt-colors-text-warning-on-accent-default': '#272126',
  /** Use as text color for elements in warning accentuated context on hover interaction. */
  '--dt-colors-text-warning-on-accent-default-hover': '#272126cc',
  /** Use as text color for elements in warning accentuated context on click interaction. */
  '--dt-colors-text-warning-on-accent-default-active': '#27212699',
  /** Use for critical text color on disabled state. */
  '--dt-colors-text-critical-disabled': '#b1b2d280',
  /** Use as the default critical text color. */
  '--dt-colors-text-critical-default': '#ff999c',
  /** Use as the default critical text color on hover interaction. */
  '--dt-colors-text-critical-default-hover': '#ffc1c1',
  /** Use as the default critical text color on click interaction. */
  '--dt-colors-text-critical-default-active': '#ffeceb',
  /** Use as text color for disabled elements in critical accentuated context. */
  '--dt-colors-text-critical-on-accent-disabled': '#f9f1f380',
  /** Use as text color for elements in critical accentuated context. */
  '--dt-colors-text-critical-on-accent-default': '#f9f1f3',
  /** Use as text color for elements in critical accentuated context on hover interaction. */
  '--dt-colors-text-critical-on-accent-default-hover': '#f9f1f3cc',
  /** Use as text color for elements in critical accentuated context on click interaction. */
  '--dt-colors-text-critical-on-accent-default-active': '#f9f1f399',
  /** Use for icon color on disabled state. */
  '--dt-colors-icon-neutral-disabled': '#b1b2d280',
  /** Use for subtle, understated icon color. */
  '--dt-colors-icon-neutral-subdued': '#b1b2d2',
  /** Use for subtle, understated icon color on hover interaction. */
  '--dt-colors-icon-neutral-subdued-hover': '#cecff0',
  /** Use for subtle, understated icon color on click interaction. */
  '--dt-colors-icon-neutral-subdued-active': '#ebecff',
  /** Use as the default icon color. */
  '--dt-colors-icon-neutral-default': '#ebecff',
  /** Use as the default icon color on hover interaction. */
  '--dt-colors-icon-neutral-default-hover': '#cecff0',
  /** Use as the default icon color on click interaction. */
  '--dt-colors-icon-neutral-default-active': '#b1b2d2',
  /** Use as icon color for disabled elements in accentuated context. */
  '--dt-colors-icon-neutral-on-accent-disabled': '#1f203380',
  /** Use as icon color for elements in accentuated context. */
  '--dt-colors-icon-neutral-on-accent-default': '#1f2033',
  /** Use as icon color for elements in accentuated context on hover interaction. */
  '--dt-colors-icon-neutral-on-accent-default-hover': '#1f2033cc',
  /** Use as icon color for elements in accentuated context on click interaction. */
  '--dt-colors-icon-neutral-on-accent-default-active': '#1f203399',
  /** Use for primary icon color on disabled state. */
  '--dt-colors-icon-primary-disabled': '#b1b2d280',
  /** Use as the default primary icon color. */
  '--dt-colors-icon-primary-default': '#adb0ff',
  /** Use as the default primary icon color on hover interaction. */
  '--dt-colors-icon-primary-default-hover': '#ccd0ff',
  /** Use as the default primary icon color on click interaction. */
  '--dt-colors-icon-primary-default-active': '#eef1ff',
  /** Use as icon color for disabled elements in primary accentuated context. */
  '--dt-colors-icon-primary-on-accent-disabled': '#1f203780',
  /** Use as icon color for elements in primary accentuated context. */
  '--dt-colors-icon-primary-on-accent-default': '#1f2037',
  /** Use as icon color for elements in primary accentuated context on hover interaction. */
  '--dt-colors-icon-primary-on-accent-default-hover': '#1f2037cc',
  /** Use as icon color for elements in primary accentuated context on click interaction. */
  '--dt-colors-icon-primary-on-accent-default-active': '#1f203799',
  /** Use for success icon color on disabled state. */
  '--dt-colors-icon-success-disabled': '#b1b2d280',
  /** Use as the default success icon color. */
  '--dt-colors-icon-success-default': '#6fc3ba',
  /** Use as the default success icon color on hover interaction. */
  '--dt-colors-icon-success-default-hover': '#8ce0d7',
  /** Use as the default success icon color on click interaction. */
  '--dt-colors-icon-success-default-active': '#aafef5',
  /** Use as icon color for disabled elements in success accentuated context. */
  '--dt-colors-icon-success-on-accent-disabled': '#1a233280',
  /** Use as icon color for elements in success accentuated context. */
  '--dt-colors-icon-success-on-accent-default': '#1a2332',
  /** Use as icon color for elements in success accentuated context on hover interaction. */
  '--dt-colors-icon-success-on-accent-default-hover': '#1a2332cc',
  /** Use as icon color for elements in success accentuated context on click interaction. */
  '--dt-colors-icon-success-on-accent-default-active': '#1a233299',
  /** Use for warning icon color on disabled state. */
  '--dt-colors-icon-warning-disabled': '#b1b2d280',
  /** Use as the default warning icon color. */
  '--dt-colors-icon-warning-default': '#eea83f',
  /** Use as the default warning icon color on hover interaction. */
  '--dt-colors-icon-warning-default-hover': '#ffc563',
  /** Use as the default warning icon color on click interaction. */
  '--dt-colors-icon-warning-default-active': '#ffecc3',
  /** Use as icon color for disabled elements in warning accentuated context. */
  '--dt-colors-icon-warning-on-accent-disabled': '#27212680',
  /** Use as icon color for elements in warning accentuated context. */
  '--dt-colors-icon-warning-on-accent-default': '#272126',
  /** Use as icon color for elements in warning accentuated context on hover interaction. */
  '--dt-colors-icon-warning-on-accent-default-hover': '#272126cc',
  /** Use as icon color for elements in warning accentuated context on click interaction. */
  '--dt-colors-icon-warning-on-accent-default-active': '#27212699',
  /** Use for critical icon color on disabled state. */
  '--dt-colors-icon-critical-disabled': '#b1b2d280',
  /** Use as the default critical icon color. */
  '--dt-colors-icon-critical-default': '#ff999c',
  /** Use as the default critical icon color on hover interaction. */
  '--dt-colors-icon-critical-default-hover': '#ffc1c1',
  /** Use as the default critical icon color on click interaction. */
  '--dt-colors-icon-critical-default-active': '#ffeceb',
  /** Use as icon color for disabled elements in critical accentuated context. */
  '--dt-colors-icon-critical-on-accent-disabled': '#f9f1f380',
  /** Use as icon color for elements in critical accentuated context. */
  '--dt-colors-icon-critical-on-accent-default': '#f9f1f3',
  /** Use as icon color for elements in critical accentuated context on hover interaction. */
  '--dt-colors-icon-critical-on-accent-default-hover': '#f9f1f3cc',
  /** Use as icon color for elements in critical accentuated context on click interaction. */
  '--dt-colors-icon-critical-on-accent-default-active': '#f9f1f399',
  /** Use to style 'Comment' syntax on a code editor context. */
  '--dt-colors-syntax-comment': '#b2b3cd',
  /** Use to style 'String' syntax on a code editor context. */
  '--dt-colors-syntax-string': '#80dbca',
  /** Use to style 'Variable' syntax on a code editor context. */
  '--dt-colors-syntax-variable': '#abb1ed',
  /** Use to style 'Number' syntax on a code editor context. */
  '--dt-colors-syntax-number': '#fd8fe1',
  /** Use to style 'Punctuation' syntax on a code editor context. */
  '--dt-colors-syntax-punctuation': '#cfa3f3',
  /** Use to style 'Function' syntax on a code editor context. */
  '--dt-colors-syntax-function': '#abb1ed',
  /** Use to style 'Classname' syntax on a code editor context. */
  '--dt-colors-syntax-classname': '#f0f0f5',
  /** Use to style 'Tag' syntax on a code editor context. */
  '--dt-colors-syntax-tag': '#ff96a6',
  /** Use to style 'Operators' syntax on a code editor context. */
  '--dt-colors-syntax-operators': '#cfa3f3',
  /** Use to style 'Boolean' syntax on a code editor context. */
  '--dt-colors-syntax-boolean': '#fe9b7d',
  '--dt-colors-charts-categorical-color-01-default': '#0072f5',
  '--dt-colors-charts-categorical-color-02-default': '#e0e2e3',
  '--dt-colors-charts-categorical-color-03-default': '#00a46b',
  '--dt-colors-charts-categorical-color-04-default': '#ff41af',
  '--dt-colors-charts-categorical-color-05-default': '#868b8f',
  '--dt-colors-charts-categorical-color-06-default': '#c4ad00',
  '--dt-colors-charts-categorical-color-07-default': '#00afbe',
  '--dt-colors-charts-categorical-color-08-default': '#9f81ff',
  '--dt-colors-charts-categorical-color-09-default': '#4bb700',
  '--dt-colors-charts-categorical-color-10-default': '#aa673f',
  '--dt-colors-charts-categorical-color-11-default': '#95c0ff',
  '--dt-colors-charts-categorical-color-12-default': '#ff0244',
  '--dt-colors-charts-categorical-color-13-default': '#00dcbe',
  '--dt-colors-charts-categorical-color-14-default': '#ff8643',
  '--dt-colors-charts-categorical-color-15-default': '#a200c5',
  '--dt-colors-charts-categorical-vivid-color-01-default': '#00d6e9',
  '--dt-colors-charts-categorical-vivid-color-02-default': '#9166ff',
  '--dt-colors-charts-categorical-vivid-color-03-default': '#ff5864',
  '--dt-colors-charts-categorical-vivid-color-04-default': '#ffe600',
  '--dt-colors-charts-categorical-vivid-color-05-default': '#009caa',
  '--dt-colors-charts-categorical-vivid-color-06-default': '#ff8643',
  '--dt-colors-charts-categorical-vivid-color-07-default': '#e89bff',
  '--dt-colors-charts-categorical-vivid-color-08-default': '#00b778',
  '--dt-colors-charts-categorical-vivid-color-09-default': '#00f0cf',
  '--dt-colors-charts-categorical-vivid-color-10-default': '#ffbfa0',
  '--dt-colors-charts-categorical-vivid-color-11-default': '#d0c7ff',
  '--dt-colors-charts-categorical-vivid-color-12-default': '#95c0ff',
  '--dt-colors-charts-categorical-vivid-color-13-default': '#f200a0',
  '--dt-colors-charts-categorical-vivid-color-14-default': '#2f86ff',
  '--dt-colors-charts-categorical-vivid-color-15-default': '#4bb700',
  '--dt-colors-charts-categorical-themed-purple-rain-color-01-default':
    '#b900e1',
  '--dt-colors-charts-categorical-themed-purple-rain-color-02-default':
    '#b39a00',
  '--dt-colors-charts-categorical-themed-purple-rain-color-03-default':
    '#ff41af',
  '--dt-colors-charts-categorical-themed-purple-rain-color-04-default':
    '#9f81ff',
  '--dt-colors-charts-categorical-themed-purple-rain-color-05-default':
    '#aa673f',
  '--dt-colors-charts-categorical-themed-purple-rain-color-06-default':
    '#ff0244',
  '--dt-colors-charts-categorical-themed-swamps-color-01-default': '#008e7a',
  '--dt-colors-charts-categorical-themed-swamps-color-02-default': '#979ba0',
  '--dt-colors-charts-categorical-themed-swamps-color-03-default': '#4bb700',
  '--dt-colors-charts-categorical-themed-swamps-color-04-default': '#aa673f',
  '--dt-colors-charts-categorical-themed-swamps-color-05-default': '#e0e2e3',
  '--dt-colors-charts-categorical-themed-swamps-color-06-default': '#b39a00',
  '--dt-colors-charts-categorical-themed-fireplace-color-01-default': '#e3003b',
  '--dt-colors-charts-categorical-themed-fireplace-color-02-default': '#ff41af',
  '--dt-colors-charts-categorical-themed-fireplace-color-03-default': '#f56c00',
  '--dt-colors-charts-categorical-themed-fireplace-color-04-default': '#b39a00',
  '--dt-colors-charts-categorical-themed-fireplace-color-05-default': '#aa673f',
  '--dt-colors-charts-categorical-themed-fireplace-color-06-default': '#b900e1',
  '--dt-colors-charts-categorical-themed-blue-steel-color-01-default':
    '#00afbe',
  '--dt-colors-charts-categorical-themed-blue-steel-color-02-default':
    '#979ba0',
  '--dt-colors-charts-categorical-themed-blue-steel-color-03-default':
    '#95c0ff',
  '--dt-colors-charts-categorical-themed-blue-steel-color-04-default':
    '#9f81ff',
  '--dt-colors-charts-categorical-themed-blue-steel-color-05-default':
    '#0063d6',
  '--dt-colors-charts-categorical-themed-blue-steel-color-06-default':
    '#cdcfd2',
  '--dt-colors-charts-categorical-themed-neon-color-01-default': '#8546ff',
  '--dt-colors-charts-categorical-themed-neon-color-02-default': '#ffe600',
  '--dt-colors-charts-categorical-themed-neon-color-03-default': '#00dcbe',
  '--dt-colors-charts-categorical-themed-neon-color-04-default': '#ff41af',
  '--dt-colors-charts-categorical-themed-neon-color-05-default': '#54cb00',
  '--dt-colors-charts-categorical-themed-neon-color-06-default': '#f56c00',
  '--dt-colors-charts-categorical-themed-aurora-color-01-default': '#e17aff',
  '--dt-colors-charts-categorical-themed-aurora-color-02-default': '#00cb86',
  '--dt-colors-charts-categorical-themed-aurora-color-03-default': '#d100fd',
  '--dt-colors-charts-categorical-themed-aurora-color-04-default': '#ff98ca',
  '--dt-colors-charts-categorical-themed-aurora-color-05-default': '#68ffe2',
  '--dt-colors-charts-categorical-themed-aurora-color-06-default': '#67f400',
  '--dt-colors-charts-categorical-themed-overdrive-color-01-default': '#f200a0',
  '--dt-colors-charts-categorical-themed-overdrive-color-02-default': '#ffe600',
  '--dt-colors-charts-categorical-themed-overdrive-color-03-default': '#ff0244',
  '--dt-colors-charts-categorical-themed-overdrive-color-04-default': '#f56c00',
  '--dt-colors-charts-categorical-themed-overdrive-color-05-default': '#ffa476',
  '--dt-colors-charts-categorical-themed-overdrive-color-06-default': '#c4ad00',
  '--dt-colors-charts-categorical-themed-tide-color-01-default': '#00e094',
  '--dt-colors-charts-categorical-themed-tide-color-02-default': '#9166ff',
  '--dt-colors-charts-categorical-themed-tide-color-03-default': '#559aff',
  '--dt-colors-charts-categorical-themed-tide-color-04-default': '#008a97',
  '--dt-colors-charts-categorical-themed-tide-color-05-default': '#bfb1ff',
  '--dt-colors-charts-categorical-themed-tide-color-06-default': '#00b49b',
  '--dt-colors-charts-status-ideal-default': '#00cb86',
  '--dt-colors-charts-status-good-default': '#2f86ff',
  '--dt-colors-charts-status-neutral-default': '#575a5e',
  '--dt-colors-charts-status-warning-default': '#e0c800',
  '--dt-colors-charts-status-critical-default': '#ff0244',
  '--dt-colors-charts-logstatus-error-default': '#ff0244',
  '--dt-colors-charts-logstatus-warning-default': '#e0c800',
  '--dt-colors-charts-logstatus-info-default': '#0072f5',
  '--dt-colors-charts-logstatus-none-default': '#676a6e',
  '--dt-colors-charts-loglevel-emergency-default': '#c60032',
  '--dt-colors-charts-loglevel-error-default': '#ff0244',
  '--dt-colors-charts-loglevel-alert-default': '#f200a0',
  '--dt-colors-charts-loglevel-critical-default': '#ff73bc',
  '--dt-colors-charts-loglevel-severe-default': '#f56c00',
  '--dt-colors-charts-loglevel-warning-default': '#e0c800',
  '--dt-colors-charts-loglevel-notice-default': '#00b778',
  '--dt-colors-charts-loglevel-info-default': '#0072f5',
  '--dt-colors-charts-loglevel-debug-default': '#9f81ff',
  '--dt-colors-charts-loglevel-none-default': '#676a6e',
  '--dt-colors-charts-apdex-excellent-default': '#00b778',
  '--dt-colors-charts-apdex-good-default': '#00915e',
  '--dt-colors-charts-apdex-fair-default': '#e0c800',
  '--dt-colors-charts-apdex-poor-default': '#f56c00',
  '--dt-colors-charts-apdex-unacceptable-default': '#ff0244',
  '--dt-colors-charts-security-risk-level-muted-default': '#979ba0',
  '--dt-colors-charts-security-risk-level-critical-default': '#c60032',
  '--dt-colors-charts-security-risk-level-high-default': '#ff0244',
  '--dt-colors-charts-security-risk-level-medium-default': '#e0c800',
  '--dt-colors-charts-security-risk-level-low-default': '#0072f5',
  '--dt-colors-charts-security-risk-level-none-default': '#676a6e',
  '--dt-colors-charts-vulnerability-status-muted-default': '#979ba0',
  '--dt-colors-charts-vulnerability-status-resolved-default': '#00b778',
  '--dt-colors-charts-vulnerability-status-affected-default': '#ff0244',
  '--dt-colors-charts-threshold-good-default': '#00b778',
  '--dt-colors-charts-threshold-warning-default': '#e0c800',
  '--dt-colors-charts-threshold-bad-default': '#ff0244',
  '--dt-colors-charts-rainbow-red-default': '#ff0244',
  '--dt-colors-charts-rainbow-orange-default': '#f56c00',
  '--dt-colors-charts-rainbow-yellow-default': '#e0c800',
  '--dt-colors-charts-rainbow-moss-default': '#00b778',
  '--dt-colors-charts-rainbow-blue-default': '#0072f5',
  '--dt-colors-charts-rainbow-magenta-default': '#b900e1',
  '--dt-colors-charts-sequential-pink-purple-color-01-default': '#ff41af',
  '--dt-colors-charts-sequential-pink-purple-color-02-default': '#e750b5',
  '--dt-colors-charts-sequential-pink-purple-color-03-default': '#d059ba',
  '--dt-colors-charts-sequential-pink-purple-color-04-default': '#b760bf',
  '--dt-colors-charts-sequential-pink-purple-color-05-default': '#9f64c4',
  '--dt-colors-charts-sequential-pink-purple-color-06-default': '#8466c9',
  '--dt-colors-charts-sequential-pink-purple-color-07-default': '#6866cd',
  '--dt-colors-charts-sequential-pink-purple-color-08-default': '#4665d2',
  '--dt-colors-charts-sequential-pink-purple-color-09-default': '#0063d6',
  '--dt-colors-charts-sequential-blue-turquoise-color-01-default': '#0063d6',
  '--dt-colors-charts-sequential-blue-turquoise-color-02-default': '#006fd0',
  '--dt-colors-charts-sequential-blue-turquoise-color-03-default': '#007bca',
  '--dt-colors-charts-sequential-blue-turquoise-color-04-default': '#0085c3',
  '--dt-colors-charts-sequential-blue-turquoise-color-05-default': '#008fbc',
  '--dt-colors-charts-sequential-blue-turquoise-color-06-default': '#0099b5',
  '--dt-colors-charts-sequential-blue-turquoise-color-07-default': '#00a2ad',
  '--dt-colors-charts-sequential-blue-turquoise-color-08-default': '#00aba4',
  '--dt-colors-charts-sequential-blue-turquoise-color-09-default': '#00b49b',
  '--dt-colors-charts-sequential-blue-color-01-default': '#0054b8',
  '--dt-colors-charts-sequential-blue-color-02-default': '#0063d6',
  '--dt-colors-charts-sequential-blue-color-03-default': '#0072f5',
  '--dt-colors-charts-sequential-blue-color-04-default': '#2f86ff',
  '--dt-colors-charts-sequential-blue-color-05-default': '#559aff',
  '--dt-colors-charts-sequential-blue-color-06-default': '#76adff',
  '--dt-colors-charts-sequential-blue-color-07-default': '#95c0ff',
  '--dt-colors-charts-sequential-blue-color-08-default': '#b3d1ff',
  '--dt-colors-charts-sequential-blue-color-09-default': '#d0e3ff',
  '--dt-colors-charts-sequential-grey-color-01-default': '#575a5e',
  '--dt-colors-charts-sequential-grey-color-02-default': '#676a6e',
  '--dt-colors-charts-sequential-grey-color-03-default': '#767a7f',
  '--dt-colors-charts-sequential-grey-color-04-default': '#868b8f',
  '--dt-colors-charts-sequential-grey-color-05-default': '#979ba0',
  '--dt-colors-charts-sequential-grey-color-06-default': '#a9acb0',
  '--dt-colors-charts-sequential-grey-color-07-default': '#bbbec1',
  '--dt-colors-charts-sequential-grey-color-08-default': '#cdcfd2',
  '--dt-colors-charts-sequential-grey-color-09-default': '#e0e2e3',
  '--dt-colors-charts-sequential-moss-color-01-default': '#006b45',
  '--dt-colors-charts-sequential-moss-color-02-default': '#007e51',
  '--dt-colors-charts-sequential-moss-color-03-default': '#00915e',
  '--dt-colors-charts-sequential-moss-color-04-default': '#00a46b',
  '--dt-colors-charts-sequential-moss-color-05-default': '#00b778',
  '--dt-colors-charts-sequential-moss-color-06-default': '#00cb86',
  '--dt-colors-charts-sequential-moss-color-07-default': '#00e094',
  '--dt-colors-charts-sequential-moss-color-08-default': '#00f5a2',
  '--dt-colors-charts-sequential-moss-color-09-default': '#81ffc0',
  '--dt-colors-charts-sequential-turquoise-color-01-default': '#00695a',
  '--dt-colors-charts-sequential-turquoise-color-02-default': '#007b6a',
  '--dt-colors-charts-sequential-turquoise-color-03-default': '#008e7a',
  '--dt-colors-charts-sequential-turquoise-color-04-default': '#00a18a',
  '--dt-colors-charts-sequential-turquoise-color-05-default': '#00b49b',
  '--dt-colors-charts-sequential-turquoise-color-06-default': '#00c8ac',
  '--dt-colors-charts-sequential-turquoise-color-07-default': '#00dcbe',
  '--dt-colors-charts-sequential-turquoise-color-08-default': '#00f0cf',
  '--dt-colors-charts-sequential-turquoise-color-09-default': '#68ffe2',
  '--dt-colors-charts-sequential-pink-color-01-default': '#a10069',
  '--dt-colors-charts-sequential-pink-color-02-default': '#bb007b',
  '--dt-colors-charts-sequential-pink-color-03-default': '#d7008e',
  '--dt-colors-charts-sequential-pink-color-04-default': '#f200a0',
  '--dt-colors-charts-sequential-pink-color-05-default': '#ff41af',
  '--dt-colors-charts-sequential-pink-color-06-default': '#ff73bc',
  '--dt-colors-charts-sequential-pink-color-07-default': '#ff98ca',
  '--dt-colors-charts-sequential-pink-color-08-default': '#ffb7d8',
  '--dt-colors-charts-sequential-pink-color-09-default': '#ffd4e7',
  '--dt-colors-charts-sequential-yellow-color-01-default': '#755300',
  '--dt-colors-charts-sequential-yellow-color-02-default': '#846500',
  '--dt-colors-charts-sequential-yellow-color-03-default': '#947600',
  '--dt-colors-charts-sequential-yellow-color-04-default': '#a38800',
  '--dt-colors-charts-sequential-yellow-color-05-default': '#b39a00',
  '--dt-colors-charts-sequential-yellow-color-06-default': '#c4ad00',
  '--dt-colors-charts-sequential-yellow-color-07-default': '#e0c800',
  '--dt-colors-charts-sequential-yellow-color-08-default': '#ffe600',
  '--dt-colors-charts-sequential-yellow-color-09-default': '#feee82',
  '--dt-colors-charts-sequential-petrol-color-01-default': '#006670',
  '--dt-colors-charts-sequential-petrol-color-02-default': '#007883',
  '--dt-colors-charts-sequential-petrol-color-03-default': '#008a97',
  '--dt-colors-charts-sequential-petrol-color-04-default': '#009caa',
  '--dt-colors-charts-sequential-petrol-color-05-default': '#00afbe',
  '--dt-colors-charts-sequential-petrol-color-06-default': '#00c2d3',
  '--dt-colors-charts-sequential-petrol-color-07-default': '#00d6e9',
  '--dt-colors-charts-sequential-petrol-color-08-default': '#00eafe',
  '--dt-colors-charts-sequential-petrol-color-09-default': '#96f3ff',
  '--dt-colors-charts-sequential-purple-color-01-default': '#6800db',
  '--dt-colors-charts-sequential-purple-color-02-default': '#7a00fe',
  '--dt-colors-charts-sequential-purple-color-03-default': '#8546ff',
  '--dt-colors-charts-sequential-purple-color-04-default': '#9166ff',
  '--dt-colors-charts-sequential-purple-color-05-default': '#9f81ff',
  '--dt-colors-charts-sequential-purple-color-06-default': '#af9aff',
  '--dt-colors-charts-sequential-purple-color-07-default': '#bfb1ff',
  '--dt-colors-charts-sequential-purple-color-08-default': '#d0c7ff',
  '--dt-colors-charts-sequential-purple-color-09-default': '#e2ddff',
  '--dt-colors-charts-sequential-pear-color-01-default': '#296b00',
  '--dt-colors-charts-sequential-pear-color-02-default': '#317e00',
  '--dt-colors-charts-sequential-pear-color-03-default': '#3a9100',
  '--dt-colors-charts-sequential-pear-color-04-default': '#42a300',
  '--dt-colors-charts-sequential-pear-color-05-default': '#4bb700',
  '--dt-colors-charts-sequential-pear-color-06-default': '#54cb00',
  '--dt-colors-charts-sequential-pear-color-07-default': '#5de000',
  '--dt-colors-charts-sequential-pear-color-08-default': '#67f400',
  '--dt-colors-charts-sequential-pear-color-09-default': '#9dff7a',
  '--dt-colors-charts-sequential-brown-color-01-default': '#7f4b2d',
  '--dt-colors-charts-sequential-brown-color-02-default': '#945936',
  '--dt-colors-charts-sequential-brown-color-03-default': '#aa673f',
  '--dt-colors-charts-sequential-brown-color-04-default': '#c07448',
  '--dt-colors-charts-sequential-brown-color-05-default': '#d68352',
  '--dt-colors-charts-sequential-brown-color-06-default': '#e69668',
  '--dt-colors-charts-sequential-brown-color-07-default': '#ebae8d',
  '--dt-colors-charts-sequential-brown-color-08-default': '#f0c5ae',
  '--dt-colors-charts-sequential-brown-color-09-default': '#f6dcce',
  '--dt-colors-charts-sequential-red-color-01-default': '#aa002a',
  '--dt-colors-charts-sequential-red-color-02-default': '#c60032',
  '--dt-colors-charts-sequential-red-color-03-default': '#e3003b',
  '--dt-colors-charts-sequential-red-color-04-default': '#ff0244',
  '--dt-colors-charts-sequential-red-color-05-default': '#ff5864',
  '--dt-colors-charts-sequential-red-color-06-default': '#ff7f83',
  '--dt-colors-charts-sequential-red-color-07-default': '#ff9f9f',
  '--dt-colors-charts-sequential-red-color-08-default': '#ffbbba',
  '--dt-colors-charts-sequential-red-color-09-default': '#ffd6d5',
  '--dt-colors-charts-sequential-magenta-color-01-default': '#8a00a9',
  '--dt-colors-charts-sequential-magenta-color-02-default': '#a200c5',
  '--dt-colors-charts-sequential-magenta-color-03-default': '#b900e1',
  '--dt-colors-charts-sequential-magenta-color-04-default': '#d100fd',
  '--dt-colors-charts-sequential-magenta-color-05-default': '#d952ff',
  '--dt-colors-charts-sequential-magenta-color-06-default': '#e17aff',
  '--dt-colors-charts-sequential-magenta-color-07-default': '#e89bff',
  '--dt-colors-charts-sequential-magenta-color-08-default': '#eeb8ff',
  '--dt-colors-charts-sequential-magenta-color-09-default': '#f5d4ff',
  '--dt-colors-charts-sequential-orange-color-01-default': '#913d00',
  '--dt-colors-charts-sequential-orange-color-02-default': '#aa4800',
  '--dt-colors-charts-sequential-orange-color-03-default': '#c35400',
  '--dt-colors-charts-sequential-orange-color-04-default': '#db6000',
  '--dt-colors-charts-sequential-orange-color-05-default': '#f56c00',
  '--dt-colors-charts-sequential-orange-color-06-default': '#ff8643',
  '--dt-colors-charts-sequential-orange-color-07-default': '#ffa476',
  '--dt-colors-charts-sequential-orange-color-08-default': '#ffbfa0',
  '--dt-colors-charts-sequential-orange-color-09-default': '#ffd8c6',
  '--dt-colors-charts-diverging-orange-blue-color-01-default': '#913d00',
  '--dt-colors-charts-diverging-orange-blue-color-02-default': '#c35400',
  '--dt-colors-charts-diverging-orange-blue-color-03-default': '#f56c00',
  '--dt-colors-charts-diverging-orange-blue-color-04-default': '#ffa476',
  '--dt-colors-charts-diverging-orange-blue-color-05-default': '#ffd8c6',
  '--dt-colors-charts-diverging-orange-blue-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-orange-blue-color-07-default': '#d0e3ff',
  '--dt-colors-charts-diverging-orange-blue-color-08-default': '#95c0ff',
  '--dt-colors-charts-diverging-orange-blue-color-09-default': '#559aff',
  '--dt-colors-charts-diverging-orange-blue-color-10-default': '#0072f5',
  '--dt-colors-charts-diverging-orange-blue-color-11-default': '#0054b8',
  '--dt-colors-charts-diverging-red-blue-color-01-default': '#aa002a',
  '--dt-colors-charts-diverging-red-blue-color-02-default': '#e3003b',
  '--dt-colors-charts-diverging-red-blue-color-03-default': '#ff5864',
  '--dt-colors-charts-diverging-red-blue-color-04-default': '#ff9f9f',
  '--dt-colors-charts-diverging-red-blue-color-05-default': '#ffd6d5',
  '--dt-colors-charts-diverging-red-blue-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-red-blue-color-07-default': '#d0e3ff',
  '--dt-colors-charts-diverging-red-blue-color-08-default': '#95c0ff',
  '--dt-colors-charts-diverging-red-blue-color-09-default': '#559aff',
  '--dt-colors-charts-diverging-red-blue-color-10-default': '#0072f5',
  '--dt-colors-charts-diverging-red-blue-color-11-default': '#0054b8',
  '--dt-colors-charts-diverging-red-purple-color-01-default': '#aa002a',
  '--dt-colors-charts-diverging-red-purple-color-02-default': '#e3003b',
  '--dt-colors-charts-diverging-red-purple-color-03-default': '#ff5864',
  '--dt-colors-charts-diverging-red-purple-color-04-default': '#ff9f9f',
  '--dt-colors-charts-diverging-red-purple-color-05-default': '#ffd6d5',
  '--dt-colors-charts-diverging-red-purple-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-red-purple-color-07-default': '#e2ddff',
  '--dt-colors-charts-diverging-red-purple-color-08-default': '#bfb1ff',
  '--dt-colors-charts-diverging-red-purple-color-09-default': '#9f81ff',
  '--dt-colors-charts-diverging-red-purple-color-10-default': '#8546ff',
  '--dt-colors-charts-diverging-red-purple-color-11-default': '#6800db',
  '--dt-colors-charts-diverging-blue-moss-color-01-default': '#0054b8',
  '--dt-colors-charts-diverging-blue-moss-color-02-default': '#0072f5',
  '--dt-colors-charts-diverging-blue-moss-color-03-default': '#559aff',
  '--dt-colors-charts-diverging-blue-moss-color-04-default': '#95c0ff',
  '--dt-colors-charts-diverging-blue-moss-color-05-default': '#d0e3ff',
  '--dt-colors-charts-diverging-blue-moss-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-blue-moss-color-07-default': '#81ffc0',
  '--dt-colors-charts-diverging-blue-moss-color-08-default': '#00e094',
  '--dt-colors-charts-diverging-blue-moss-color-09-default': '#00b778',
  '--dt-colors-charts-diverging-blue-moss-color-10-default': '#00915e',
  '--dt-colors-charts-diverging-blue-moss-color-11-default': '#006b45',
  '--dt-colors-charts-diverging-purple-yellow-color-01-default': '#6800db',
  '--dt-colors-charts-diverging-purple-yellow-color-02-default': '#8546ff',
  '--dt-colors-charts-diverging-purple-yellow-color-03-default': '#9f81ff',
  '--dt-colors-charts-diverging-purple-yellow-color-04-default': '#bfb1ff',
  '--dt-colors-charts-diverging-purple-yellow-color-05-default': '#e2ddff',
  '--dt-colors-charts-diverging-purple-yellow-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-purple-yellow-color-07-default': '#feee82',
  '--dt-colors-charts-diverging-purple-yellow-color-08-default': '#e0c800',
  '--dt-colors-charts-diverging-purple-yellow-color-09-default': '#b39a00',
  '--dt-colors-charts-diverging-purple-yellow-color-10-default': '#947600',
  '--dt-colors-charts-diverging-purple-yellow-color-11-default': '#755300',
  '--dt-colors-charts-diverging-red-green-color-01-default': '#aa002a',
  '--dt-colors-charts-diverging-red-green-color-02-default': '#e3003b',
  '--dt-colors-charts-diverging-red-green-color-03-default': '#ff5864',
  '--dt-colors-charts-diverging-red-green-color-04-default': '#ff9f9f',
  '--dt-colors-charts-diverging-red-green-color-05-default': '#ffd6d5',
  '--dt-colors-charts-diverging-red-green-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-red-green-color-07-default': '#81ffc0',
  '--dt-colors-charts-diverging-red-green-color-08-default': '#00e094',
  '--dt-colors-charts-diverging-red-green-color-09-default': '#00b778',
  '--dt-colors-charts-diverging-red-green-color-10-default': '#00915e',
  '--dt-colors-charts-diverging-red-green-color-11-default': '#006b45',
  '--dt-colors-charts-diverging-orange-petrol-color-01-default': '#913d00',
  '--dt-colors-charts-diverging-orange-petrol-color-02-default': '#c35400',
  '--dt-colors-charts-diverging-orange-petrol-color-03-default': '#f56c00',
  '--dt-colors-charts-diverging-orange-petrol-color-04-default': '#ffa476',
  '--dt-colors-charts-diverging-orange-petrol-color-05-default': '#ffd8c6',
  '--dt-colors-charts-diverging-orange-petrol-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-orange-petrol-color-07-default': '#96f3ff',
  '--dt-colors-charts-diverging-orange-petrol-color-08-default': '#00d6e9',
  '--dt-colors-charts-diverging-orange-petrol-color-09-default': '#00afbe',
  '--dt-colors-charts-diverging-orange-petrol-color-10-default': '#008a97',
  '--dt-colors-charts-diverging-orange-petrol-color-11-default': '#006670',
  '--dt-colors-charts-diverging-pink-green-color-01-default': '#a10069',
  '--dt-colors-charts-diverging-pink-green-color-02-default': '#d7008e',
  '--dt-colors-charts-diverging-pink-green-color-03-default': '#ff41af',
  '--dt-colors-charts-diverging-pink-green-color-04-default': '#ff98ca',
  '--dt-colors-charts-diverging-pink-green-color-05-default': '#ffd4e7',
  '--dt-colors-charts-diverging-pink-green-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-pink-green-color-07-default': '#81ffc0',
  '--dt-colors-charts-diverging-pink-green-color-08-default': '#00e094',
  '--dt-colors-charts-diverging-pink-green-color-09-default': '#00b778',
  '--dt-colors-charts-diverging-pink-green-color-10-default': '#00915e',
  '--dt-colors-charts-diverging-pink-green-color-11-default': '#006b45',
  /** Use as the default layer, for elements that do not need to be explicitly layered on top of other elements. */
  '--dt-elevations-default': '1',
  /** Use for elements that are pinned to a certain location while also staying on top of other content. */
  '--dt-elevations-sticky': '10',
  /** Use for elements that appear on top of all other content on the page. */
  '--dt-elevations-overlay': '20',
  /** Use for notifications that should always be visible on top of other content. */
  '--dt-elevations-notification': '1999999999',
  '--dt-spacings-size-0': '0',
  '--dt-spacings-size-2': '2px',
  '--dt-spacings-size-4': '4px',
  '--dt-spacings-size-6': '6px',
  '--dt-spacings-size-8': '8px',
  '--dt-spacings-size-12': '12px',
  '--dt-spacings-size-16': '16px',
  '--dt-spacings-size-20': '20px',
  '--dt-spacings-size-24': '24px',
  '--dt-spacings-size-28': '28px',
  '--dt-spacings-size-32': '32px',
  '--dt-spacings-size-36': '36px',
  '--dt-spacings-size-40': '40px',
  '--dt-spacings-size-48': '48px',
  '--dt-spacings-size-56': '56px',
  '--dt-spacings-size-64': '64px',
  '--dt-typography-display-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-display-level-1-weight': '600',
  '--dt-typography-display-level-1-size': '64px',
  '--dt-typography-display-level-1-line-height': '1.1875',
  '--dt-typography-display-level-1-text-decoration': 'none',
  '--dt-typography-display-level-1-text-transform': 'none',
  '--dt-typography-display-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-display-level-2-weight': '600',
  '--dt-typography-display-level-2-size': '56px',
  '--dt-typography-display-level-2-line-height': '1.2142857143',
  '--dt-typography-display-level-2-text-decoration': 'none',
  '--dt-typography-display-level-2-text-transform': 'none',
  '--dt-typography-display-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-display-level-3-weight': '600',
  '--dt-typography-display-level-3-size': '48px',
  '--dt-typography-display-level-3-line-height': '1.25',
  '--dt-typography-display-level-3-text-decoration': 'none',
  '--dt-typography-display-level-3-text-transform': 'none',
  '--dt-typography-heading-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-1-weight': '600',
  '--dt-typography-heading-level-1-size': '32px',
  '--dt-typography-heading-level-1-line-height': '1.25',
  '--dt-typography-heading-level-1-text-decoration': 'none',
  '--dt-typography-heading-level-1-text-transform': 'none',
  '--dt-typography-heading-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-2-weight': '600',
  '--dt-typography-heading-level-2-size': '28px',
  '--dt-typography-heading-level-2-line-height': '1.2857142857',
  '--dt-typography-heading-level-2-text-decoration': 'none',
  '--dt-typography-heading-level-2-text-transform': 'none',
  '--dt-typography-heading-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-3-weight': '600',
  '--dt-typography-heading-level-3-size': '24px',
  '--dt-typography-heading-level-3-line-height': '1.3333333333',
  '--dt-typography-heading-level-3-text-decoration': 'none',
  '--dt-typography-heading-level-3-text-transform': 'none',
  '--dt-typography-heading-level-4-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-4-weight': '600',
  '--dt-typography-heading-level-4-size': '20px',
  '--dt-typography-heading-level-4-line-height': '1.4',
  '--dt-typography-heading-level-4-text-decoration': 'none',
  '--dt-typography-heading-level-4-text-transform': 'none',
  '--dt-typography-heading-level-5-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-5-weight': '600',
  '--dt-typography-heading-level-5-size': '16px',
  '--dt-typography-heading-level-5-line-height': '1.5',
  '--dt-typography-heading-level-5-text-decoration': 'none',
  '--dt-typography-heading-level-5-text-transform': 'none',
  '--dt-typography-heading-level-6-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-6-weight': '600',
  '--dt-typography-heading-level-6-size': '14px',
  '--dt-typography-heading-level-6-line-height': '1.4285714286',
  '--dt-typography-heading-level-6-text-decoration': 'none',
  '--dt-typography-heading-level-6-text-transform': 'none',
  '--dt-typography-subtitle-display-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-display-level-1-weight': '400',
  '--dt-typography-subtitle-display-level-1-size': '28px',
  '--dt-typography-subtitle-display-level-1-line-height': '1.4285714286',
  '--dt-typography-subtitle-display-level-1-text-decoration': 'none',
  '--dt-typography-subtitle-display-level-1-text-transform': 'none',
  '--dt-typography-subtitle-display-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-display-level-2-weight': '400',
  '--dt-typography-subtitle-display-level-2-size': '24px',
  '--dt-typography-subtitle-display-level-2-line-height': '1.5',
  '--dt-typography-subtitle-display-level-2-text-decoration': 'none',
  '--dt-typography-subtitle-display-level-2-text-transform': 'none',
  '--dt-typography-subtitle-display-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-display-level-3-weight': '400',
  '--dt-typography-subtitle-display-level-3-size': '21px',
  '--dt-typography-subtitle-display-level-3-line-height': '1.5238095238',
  '--dt-typography-subtitle-display-level-3-text-decoration': 'none',
  '--dt-typography-subtitle-display-level-3-text-transform': 'none',
  '--dt-typography-subtitle-heading-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-heading-level-1-weight': '400',
  '--dt-typography-subtitle-heading-level-1-size': '21px',
  '--dt-typography-subtitle-heading-level-1-line-height': '1.5238095238',
  '--dt-typography-subtitle-heading-level-1-text-decoration': 'none',
  '--dt-typography-subtitle-heading-level-1-text-transform': 'none',
  '--dt-typography-subtitle-heading-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-heading-level-2-weight': '400',
  '--dt-typography-subtitle-heading-level-2-size': '18px',
  '--dt-typography-subtitle-heading-level-2-line-height': '1.5555555556',
  '--dt-typography-subtitle-heading-level-2-text-decoration': 'none',
  '--dt-typography-subtitle-heading-level-2-text-transform': 'none',
  '--dt-typography-subtitle-heading-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-heading-level-3-weight': '400',
  '--dt-typography-subtitle-heading-level-3-size': '16px',
  '--dt-typography-subtitle-heading-level-3-line-height': '1.5',
  '--dt-typography-subtitle-heading-level-3-text-decoration': 'none',
  '--dt-typography-subtitle-heading-level-3-text-transform': 'none',
  '--dt-typography-text-base-default-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-base-default-weight': '400',
  '--dt-typography-text-base-default-size': '14px',
  '--dt-typography-text-base-default-line-height': '1.4285714286',
  '--dt-typography-text-base-default-text-decoration': 'none',
  '--dt-typography-text-base-default-text-transform': 'none',
  '--dt-typography-text-base-emphasized-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-base-emphasized-weight': '500',
  '--dt-typography-text-base-emphasized-size': '14px',
  '--dt-typography-text-base-emphasized-line-height': '1.4285714286',
  '--dt-typography-text-base-emphasized-text-decoration': 'none',
  '--dt-typography-text-base-emphasized-text-transform': 'none',
  '--dt-typography-text-small-default-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-small-default-weight': '400',
  '--dt-typography-text-small-default-size': '12px',
  '--dt-typography-text-small-default-line-height': '1.333333333',
  '--dt-typography-text-small-default-text-decoration': 'none',
  '--dt-typography-text-small-default-text-transform': 'none',
  '--dt-typography-text-small-emphasized-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-small-emphasized-weight': '500',
  '--dt-typography-text-small-emphasized-size': '12px',
  '--dt-typography-text-small-emphasized-line-height': '1.333333333',
  '--dt-typography-text-small-emphasized-text-decoration': 'none',
  '--dt-typography-text-small-emphasized-text-transform': 'none',
  '--dt-typography-code-base-default-family': 'Roboto Mono,monospace',
  '--dt-typography-code-base-default-weight': '400',
  '--dt-typography-code-base-default-size': '14px',
  '--dt-typography-code-base-default-line-height': '1.4285714286',
  '--dt-typography-code-base-default-text-decoration': 'none',
  '--dt-typography-code-base-default-text-transform': 'none',
  '--dt-typography-code-base-emphasized-family': 'Roboto Mono,monospace',
  '--dt-typography-code-base-emphasized-weight': '500',
  '--dt-typography-code-base-emphasized-size': '14px',
  '--dt-typography-code-base-emphasized-line-height': '1.4285714286',
  '--dt-typography-code-base-emphasized-text-decoration': 'none',
  '--dt-typography-code-base-emphasized-text-transform': 'none',
  '--dt-typography-code-small-default-family': 'Roboto Mono,monospace',
  '--dt-typography-code-small-default-weight': '400',
  '--dt-typography-code-small-default-size': '12px',
  '--dt-typography-code-small-default-line-height': '1.333333333',
  '--dt-typography-code-small-default-text-decoration': 'none',
  '--dt-typography-code-small-default-text-transform': 'none',
  '--dt-typography-code-small-emphasized-family': 'Roboto Mono,monospace',
  '--dt-typography-code-small-emphasized-weight': '500',
  '--dt-typography-code-small-emphasized-size': '12px',
  '--dt-typography-code-small-emphasized-line-height': '1.333333333',
  '--dt-typography-code-small-emphasized-text-decoration': 'none',
  '--dt-typography-code-small-emphasized-text-transform': 'none',
  '--dt-animations-open-duration-fast': '170ms',
  '--dt-animations-open-duration-base': '250ms',
  '--dt-animations-open-duration-slow': '400ms',
  '--dt-animations-open-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-close-duration-fast': '0ms',
  '--dt-animations-close-duration-base': '170ms',
  '--dt-animations-close-duration-slow': '250ms',
  '--dt-animations-close-easing': 'cubic-bezier(0.5, 0, 1, 1)',
  '--dt-animations-slide-in-duration-fast': '200ms',
  '--dt-animations-slide-in-duration-base': '300ms',
  '--dt-animations-slide-in-duration-slow': '400ms',
  '--dt-animations-slide-in-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-slide-out-duration-fast': '150ms',
  '--dt-animations-slide-out-duration-base': '250ms',
  '--dt-animations-slide-out-duration-slow': '350ms',
  '--dt-animations-slide-out-easing': 'cubic-bezier(0.8, 0, 0.5, 1)',
  '--dt-animations-fade-in-duration-fast': '150ms',
  '--dt-animations-fade-in-duration-base': '250ms',
  '--dt-animations-fade-in-duration-slow': '350ms',
  '--dt-animations-fade-in-easing': 'cubic-bezier(0.5, 0, 1, 1)',
  '--dt-animations-fade-out-duration-fast': '150ms',
  '--dt-animations-fade-out-duration-base': '250ms',
  '--dt-animations-fade-out-duration-slow': '350ms',
  '--dt-animations-fade-out-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-hover-duration-base': '150ms',
  '--dt-animations-hover-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-staggered-motion-duration-fast': '250ms',
  '--dt-animations-staggered-motion-duration-base': '350ms',
  '--dt-animations-staggered-motion-duration-slow': '400ms',
  '--dt-animations-staggered-motion-offset-fast': '20ms',
  '--dt-animations-staggered-motion-offset-base': '30ms',
  '--dt-animations-staggered-motion-offset-slow': '50ms',
  '--dt-animations-staggered-motion-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-expand-collapse-duration-fast': '250ms',
  '--dt-animations-expand-collapse-duration-base': '400ms',
  '--dt-animations-expand-collapse-duration-slow': '600ms',
  '--dt-animations-expand-collapse-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
  '--dt-animations-move-duration-fast': '150ms',
  '--dt-animations-move-duration-base': '400ms',
  '--dt-animations-move-duration-slow': '600ms',
  '--dt-animations-move-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
  '--dt-animations-rescale-duration-fast': '170ms',
  '--dt-animations-rescale-duration-base': '250ms',
  '--dt-animations-rescale-duration-slow': '400ms',
  '--dt-animations-rescale-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
  /** Use to convey the deceleration of an object, such as when it's coming to a stop. It starts at a fast pace and then slows down at the end. */
  '--dt-easings-decelerate': 'cubic-bezier(0, 0, 0.2, 1)',
  /** Use to convey the acceleration of an object, such as when it's being launched. It starts at a slow pace and then speeds up at the end. */
  '--dt-easings-accelerate': 'cubic-bezier(0.5, 0, 1, 1)',
  /** Use to draw attention to an object. It starts slowly, accelerates in the middle, and then slows down again at the end. */
  '--dt-easings-slow-in-fast-out': 'cubic-bezier(0.8, 0, 0.5, 1)',
  /** Use to move or scale objects. It starts slowly, quickly accelerates in the middle, and slows down at the end. */
  '--dt-easings-fast-in-slow-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
  /** Use to convey a playful or elastic effect, such as when an object bounces or stretches. It overshoots its target position before settling back into place. */
  '--dt-easings-out-back': 'cubic-bezier(0.4, 1.6, 0.7, 1)',
  /** Use to create dynamic, nonlinear rotation that adds energy and movement, ideal for rotating loading indicators. */
  '--dt-easings-rotate-elastic': 'cubic-bezier(0.8, 0.3, 0.3, 0.8)',
  '--dt-timings-instant-default': '0ms',
  '--dt-timings-offset-short': '20ms',
  '--dt-timings-offset-medium': '30ms',
  '--dt-timings-offset-long': '100ms',
  '--dt-timings-offset-default': '50ms',
  '--dt-timings-fast-quick': '150ms',
  '--dt-timings-fast-default': '170ms',
  '--dt-timings-fast-moderate': '200ms',
  '--dt-timings-base-quick': '250ms',
  '--dt-timings-base-default': '300ms',
  '--dt-timings-base-moderate': '350ms',
  '--dt-timings-slow-default': '400ms',
  '--dt-timings-slow-moderate': '600ms',
  '--dt-timings-slow-gentle': '800ms',
  '--dt-timings-slowest-default': '1000ms',
  '--dt-timings-slowest-moderate': '1200ms',
  '--dt-timings-slowest-gentle': '1500ms',
};
export default customPropertiesUnified;
